<div class="d-flex flex-column gap-4">
  <div class="flex-shrink-1">
    <mat-card>
      <mat-card-content>
        <div class="d-flex flex-column gap-2">
          <div class="d-flex justify-content-between gap-2">
            <div class="d-flex justify-content-start btn-filter-date">
              <button
                (click)="quickFilterDate(btn.filter)"
                *ngFor="let btn of buttonConfigs"
                [color]="activeQuickFilterBtn === btn.filter ? 'primary' : ''"
                [ngStyle]="{
                  color:
                    activeQuickFilterBtn !== btn.filter ? '#344054' : '#FFFFFF'
                }"
                class="filter-btn"
                mat-flat-button
              >
                {{ btn.label }}
              </button>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button
                (click)="rangePicker.open()"
                class="filter-btn"
                mat-flat-button
              >
                <mat-icon svgIcon="calendar-ic"></mat-icon>
                Select Date
              </button>
              <button
                (click)="onClickFilter()"
                class="filter-btn"
                mat-flat-button
              >
                <mat-icon>filter_list</mat-icon>
                Filter
              </button>
              <mat-form-field
                [formGroup]="dateRange"
                style="position: absolute; top: 0; right: 0; visibility: hidden"
              >
                <mat-date-range-input [rangePicker]="rangePicker">
                  <input formControlName="start" matStartDate/>
                  <input formControlName="end" matEndDate/>
                </mat-date-range-input>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button
                      (click)="applyDate()"
                      color="primary"
                      mat-raised-button
                      matDateRangePickerApply
                    >
                      Apply
                    </button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>
          <div class="d-flex gap-2">
            <div class="pt-3" style="min-width: 8em">
              <ng-container *ngIf="filterDate$ | async as filterDate">
                <h4 class="rating-text" [innerHTML]="getOverallLabel(filterDate.reportCategory)" ></h4>
                <div
                  *ngIf="venueOverall$ | async as venue"
                  class="d-flex flex-column align-items-start gap-4"
                >
                  <div class="d-flex gap-2">
                    <mat-icon
                      style="height: 2em; width: 2em"
                      svgIcon="star-ic"
                    ></mat-icon>
                    <h2 class="mb-0" style="font-weight: 600; font-size: 2rem">
                      {{ venue.rating }}
                    </h2>
                  </div>
                  <div class="d-flex gap-1 align-items-center primary-color">
                    <mat-icon>trending_up</mat-icon>
                    <p class="m-0">{{ venue.trendValue }}%</p>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="flex-grow-1">
              <apx-chart
                [chart]="chart"
                [series]="chartSeries"
                [xaxis]="chartXAxis"
                [yaxis]="chartYAxis"
              >
              </apx-chart>
            </div>
            <ng-container *ngIf="filterDate$ | async as filterDate">
              <div *ngIf="filterDate?.reportCategory === 'venue'" class="pt-3 d-flex flex-column" style="min-width: 12em">
                <ng-container *ngIf="venueSection$ | async as venueSections">
                  <div *ngFor="let venue of venueSections" class="flex-grow-1">
                    <h4 class="rating-text mb-3">{{ venue.label }}</h4>
                    <div class="d-flex align-items-start gap-2">
                      <div class="d-flex gap-2">
                        <mat-icon
                          style="height: 2em; width: 2em"
                          svgIcon="star-ic"
                        ></mat-icon>
                        <h2
                          class="mb-0"
                          style="font-weight: 600; font-size: 2rem"
                        >
                          {{ venue.rating }}
                        </h2>
                      </div>
                      <div
                        class="d-flex gap-1 align-items-center primary-color"
                      >
                        <mat-icon>trending_up</mat-icon>
                        <p class="m-0">{{ venue.trendValue }}%</p>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="d-flex gap-5">
    <div class="flex-grow-1">
      <h2 class="top-rated-text">Top Rated Menus</h2>
      <mat-list *ngIf="ratedMenus$ | async as ratedMenus">
        <mat-list-item
          *ngFor="let menu of ratedMenus"
          class="p-0"
          style="height: 5em; border-top: 1px solid #eaecf0"
        >
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center gap-3 list-wrapper-menu">
              <h4 class="m-0">{{ menu.label }}</h4>
            </div>
            <div class="d-flex align-items-center gap-1 star-wrapper-menu">
              <mat-icon svgIcon="star-ic"></mat-icon>
              <span>{{ menu.rating }}</span>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <div class="flex-grow-1">
      <h2 class="top-rated-text">Top Reviewed Menus</h2>
      <mat-list *ngIf="reviewedMenus$ | async as reviewedMenus">
        <mat-list-item
          *ngFor="let menu of reviewedMenus"
          class="p-0"
          style="height: 5em; border-top: 1px solid #eaecf0"
        >
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center gap-3 list-wrapper-menu">
              <h4 class="m-0">{{ menu.label }}</h4>
            </div>
            <div class="d-flex align-items-center gap-1 star-wrapper-menu">
              <span
              >{{ menu.count }} review<span
                [innerHTML]="menu.count > 1 ? 's' : ''"
              ></span
              ></span>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
